// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1tz9T","label":"LabeledBox_label__3Koyo"};